import { Fragment, ReactNode } from 'react';

/** Parse markdown-style [text](url) links into React elements */
export const parseMarkdownLinks = (text: string, linkClassName?: string): ReactNode => {
  const parts = text.split(/(\[.*?\]\(.*?\))/g);
  if (parts.length === 1) return text;

  return parts.map((part, i) => {
    const match = part.match(/^\[(.*?)\]\((.*?)\)$/);
    if (match) {
      return (
        <a key={i} href={match[2]} className={linkClassName}>
          {match[1]}
        </a>
      );
    }
    return <Fragment key={i}>{part}</Fragment>;
  });
};
